
import { mapState, mapMutations } from "vuex";
export default {
  props: {
    itemsPerPage: Number,
  },
  computed: {
    ...mapState("blog", {
      pagination: (state) => state.pagination,
      category: (state) => state.category,
    }),
  },
  methods: {
    ...mapMutations("blog", ["GET_PAGINATION"]),
    async goFirstPage() {
      const payload = {
        firstPage: 1,
        secondPage: 2,
        fromPage: this.pagination.fromPage,
        toPage: 1,
        category: this.category.data || null,
      };

      this.GET_PAGINATION(payload);
      await this.$store.dispatch("blog/getBlogTags", {
        category: this.category.data,
        itemsPerPage: this.itemsPerPage,
      });
      window.scrollTo(0, 0);
    },
    async goToThisPage(page) {
      const payload = {
        firstPage: 1,
        fromPage: this.pagination.toPage,
        toPage: page,
        category: this.category.data || null,
      };
      this.GET_PAGINATION(payload);
      await this.$store.dispatch("blog/getBlogTags", {
        category: this.category.data,
        itemsPerPage: this.itemsPerPage,
      });
      window.scrollTo(0, 0);
    },
  },
};
